import React from "react";

const TEXT_EMPTY = "Заполните это поле";
const NOT_VALID_EMAIL = "Введите валидный адрес почты";
const TEXT_MIN_LENGTH = "Минимальная длинна поля ";
const MIN_VALUE = "Минимальное значение ";
const MAX_VALUE = "Максимальное значение ";

export default function CusForm({ children, className, onSubmit, onError }) {
  const onFormSubmit = (e) => {
    e.preventDefault();
    let isSubmit = true;
    const inputFields = {};

    const dispatchCuEvent = (message, target) => {
      const event = new CustomEvent("inputError", { detail: { message, target } });
      window.dispatchEvent(event);
      isSubmit = false;
    };

    const getInputs = (selector) => e.target.querySelectorAll(selector);

    // FIELD input
    getInputs("input").forEach((input) => {
      const name = input.getAttribute("name");
      inputFields[name] = input.value;
    });

    // CHECK_TYPE
    getInputs("input[data-type]").forEach((input) => {
      const type = input.getAttribute("data-type");
      // CHECK_VALID_EMAIL
      if (type === "email") {
        const value = input.value;
        if ((value.indexOf("@") < 0 || value.indexOf(".") < 0) && value !== "") {
          dispatchCuEvent(NOT_VALID_EMAIL, input);
        }
      } else if (type === "number") {
        // CHECK_MIN
        if (input.getAttribute("data-min")) {
          const min = +input.getAttribute("data-min");
          if (min > +input.value) dispatchCuEvent(MIN_VALUE + min, input);
        }

        if (input.getAttribute("data-max")) {
          const max = +input.getAttribute("data-max");
          if (max < +input.value) dispatchCuEvent(MAX_VALUE + max, input);
        }
      }
    });

    // CHECK_MIN_LENGTH
    getInputs("input[data-minlength]").forEach((input) => {
      const minLength = input.getAttribute("data-minlength");
      if (input.value.length < minLength && input.value !== "") {
        dispatchCuEvent(TEXT_MIN_LENGTH + minLength, input);
      }
    });

    // CHECK_TEXT_EMPTY
    getInputs("input[data-required]").forEach((input) => {
      if (input.value === "") dispatchCuEvent(TEXT_EMPTY, input);
      if (input.getAttribute("data-type") === "checkbox") {
        if (!input.checked) dispatchCuEvent(TEXT_EMPTY, input);
      }
    });

    /**
     * @textarea
     */

    // FIELD textarea
    getInputs("textarea").forEach((input) => {
      const name = input.getAttribute("name");
      inputFields[name] = input.value;
    });

    // CHECK_TEXT_EMPTY
    getInputs("textarea[data-required]").forEach((input) => {
      if (input.value === "") dispatchCuEvent(TEXT_EMPTY, input);
    });

    if (isSubmit) {
      onSubmit(e, inputFields);
    } else {
      onError(e, inputFields);
    }
  };

  return (
    <form className={className} onSubmit={onFormSubmit}>
      {children}
    </form>
  );
}
